import { render } from "./Moderate.vue?vue&type=template&id=1f98d2be&scoped=true"
import script from "./Moderate.vue?vue&type=script&lang=js"
export * from "./Moderate.vue?vue&type=script&lang=js"

import "./Moderate.vue?vue&type=style&index=0&id=1f98d2be&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f98d2be"]])

export default __exports__